import cn from 'classnames'
import _ from 'lodash'
import React from 'react'
import moment from 'moment'
import LogoutBtn from './LogoutBtn'
import DatePicker from './DatePicker'
import Linky from './Linky'

let Navbar = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  searchVal,
  setSearchVal,
  setPage,
  setLoggedIn,
  view,
  setView,
}) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      {/* <span className="navbar-brand">
        <img
          src="https://evergreenonlineleads.com/wp-content/uploads/2018/12/LogoWhite.png"
          height={20}
          alt=""
        />
      </span> */}
      <ul className="navbar-nav mr-auto">
        {[{ route: 'leads' }, { route: 'reports' }].map(({ route }) => (
          <li
            key={route}
            className={cn('nav-item', { active: view === route })}
          >
            <Linky className="nav-link" onClick={() => setView(route)}>
              {_.startCase(route)}
            </Linky>
          </li>
        ))}
      </ul>
      <div className="form-inline ml-auto">
        <input
          className="form-control mr-2"
          placeholder="Search"
          value={searchVal}
          style={{ minWidth: '280px' }}
          onChange={e => {
            setSearchVal(e.target.value)
            setPage(0)
          }}
        />
      </div>
      <DatePicker
        style={{ width: '140px' }}
        date={fromDate}
        onChange={d => {
          setFromDate(moment(d).startOf('day').valueOf())
        }}
      />
      <span className="text-white mx-2"> To </span>
      <DatePicker
        style={{ width: '140px' }}
        date={toDate}
        onChange={d => {
          setToDate(moment(d).endOf('day').valueOf())
        }}
      />
      <LogoutBtn setLoggedIn={setLoggedIn} />
    </nav>
  )
}

export default Navbar
